import request from "@/utils/request";
// 模板下载
export const careprisonimport = data => {
  return request({
    url: "/api/hz-smart-community/care/prison/import",
    data: data,
    headers: { "Content-Type": "multipart/form-data" },
    method: 'POST'
  });
};
// 模板下载
export const careprisonexport = data => {
  return request({
    url: "/api/hz-smart-community/care/prison/export",
    params: data,
    responseType: "blob"
      // method: 'POST'
  });
};

// 人员关怀列表
export const peoplelist = data => {
  return request({
    url: "/api/hz-smart-community/care/for/people/list",
    params: data
  });
};

// 人员关怀新建
export const peoplesave = data => {
  return request({
    url: "/api/hz-smart-community/care/for/people/save",
    data: data,
    method: "POST"
  });
};

// 人员关怀编辑
export const peopleupdate = data => {
  return request({
    url: "/api/hz-smart-community/care/for/people/update",
    data: data,
    method: "POST"
  });
};

// 人员关怀删除
export const peopledelete = data => {
  return request({
    url: "/api/hz-smart-community/care/for/people/delete",
    data: data,
    method: "POST"
  });
};

// 人员关怀库列表查询
export const peoplegetprison = data => {
  return request({
    url: "/api/hz-smart-community/care/prison/list",
    params: data
  });
};
// 人员关怀库列表新增
export const prisonsave = data => {
  return request({
    url: `/api/hz-smart-community/care/prison/save?careId=${data.careId}`,
    data: data.prisonIds || {},
    method: "POST"
  });
};

// 人员关怀库列表删除
export const prisondelete = data => {
  return request({
    url: "/api/hz-smart-community/care/prison/delete",
    data: data || {},
    method: "POST"
  });
};

// 人员关怀库分配查询列表
export const communitylist = data => {
  return request({
    url: "/api/hz-smart-community/sys/community/list/dutyInfo",
    data: data || {},
    method: "POST"
  });
};
// 人员关怀库分配添加修改  暂停
export const saveOrUpdateInfo = data => {
  return request({
    url: "/api/hz-smart-community/sys/community/saveOrUpdateInfo",
    data: data || {},
    method: "POST"
  });
};
export const deletedutyInfo = data => {
  return request({
    url: "/apihz-smart-community/sys/community/delete/dutyInfo",
    data: data || {},
    method: "DELETE"
  });
};

// 人员关怀库分配左侧列表
export const statisticsDutyInfo = data => {
  return request({
    url: "/api/hz-smart-community/sys/community/statistics_dutyInfo",
    params: data || {}
  });
};

// 人员关怀库详情查询列表
export const querydutyDetail = data => {
  return request({
    url: "/api/hz-smart-community/sys/community/query/dutyDetail",
    data: data || {},
    method: "POST"
  });
};

// 人员关怀库详情左侧
export const statisticsDutyDetail = data => {
  return request({
    url: "/api/hz-smart-community/sys/community/statistics_dutyDetail",
    params: data || {}
  });
};
// 人员关怀库详情处理
export const communitydutyDetail = data => {
  return request({
    url: "/api/hz-smart-community/sys/community/handle/dutyDetail",
    data: data || {},
    method: "POST"
  });
};
// 人员关怀库详情
export const dutyDetailInfo = data => {
  return request({
    url: "/api/hz-smart-community/sys/community/dutyDetail/info",
    params: data || {},

  });
};
// 人员关怀库详情误报
export const handledutyDetail = data => {
  return request({
    url: "/api/hz-smart-community/sys/community/handle/dutyDetail/" + data,
    params: data || {}
  });
};
// 老人旧居未出列表
export const oldManNotGoOut = data => {
  return request({
    url: "/api/hz-smart-community/face/search/oldManNotGoOut",
    params: data || {}
  });
};
// 重点人员库列表
export const basepeoplelist = data => {
  return request({
    url: "/apiData/hz-data-community/library/list",
    data: data,
    method: "POST"
  });
};

// 重点人员库新建
export const basepeoplesave = data => {
  return request({
    url: "/apiData/hz-data-community/library/save",
    data: data,
    method: "POST"
  });
};

// 重点人员库编辑
export const basepeopleupdate = data => {
  return request({
    url: "/apiData/hz-data-community/library/save",
    data: data,
    method: "POST"
  });
};

// 重点人员库删除
export const basepeopledelete = data => {
  return request({
    url: "/api/hz-smart-community/styp/library/delete",
    data: data,
    method: "POST"
  });
};
// 重点人员库列表查询
export const basepeoplegetprison = data => {
  return request({
    url: "/apiData/hz-data-community/face/list",
    data: data || {},
    method: "POST"
  });
};
// 重点人员列表新增
export const baseprisonsave = data => {
  return request({
    url: "/apiData/hz-data-community/face/save",
    data: data || {},
    method: "POST"
  });
};
// 重点人员列表修改
export const baseprisonupdate = data => {
  return request({
    url: "/apiData/hz-data-community/face/save",
    data: data || {},
    method: "POST"
  });
};

// 重点人员库列表删除
export const baseprisondelete = data => {
  return request({
    url: "/api/hz-smart-community/styp/face/delete",
    data: data || {},
    method: "POST"
  });
};
// 重点人员库保存（通过实有人口添加）
export const saveByPrison = data => {
  return request({
    url: "/api/hz-smart-community/styp/face/saveByPrison",
    data: data || {},
    method: "POST"
  });
};
// 重点人员库保存（通过规则批量）
export const basesaveByAge = data => {
  return request({
    url: "/api/hz-smart-community/styp/face/saveByAge",
    data: data || {},
    method: "POST"
  });
};

// 重点车辆库列表查询
export const baseCargetList = data => {
  return request({
    url: "/apiData/hz-data-community/styp/car/list",
    data: data || {},
    method: "POST"
  });
};

// 重点车辆库保存
export const baseCarSave = data => {
  return request({
    url: "/apiData/hz-data-community/styp/car/save",
    data: data || {},
    method: "POST"
  });
};

// 重点车辆库删除
export const baseCarDetele = data => {
  return request({
    url: "/apiData/hz-data-community/styp/car/detele",
    data: data || {},
    method: "POST"
  });
};

// 重点人员车辆  同步库
export const getSyncIdList = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/object_manage/group/list",
    data: data || {},
    method: "POST"
  });
};